import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gitbook = defineConnector({
  identifier: "gitbook",
  name: "GitBook",
  tagLine: "Documentation platform",
  logo,
  protocol: "http",
  tags: ["documents", "engineering"],
  defaultUrlPattern: () => "https://api\\.gitbook\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [GitBook Developer Settings](https://app.gitbook.com/account/developer) and create a new personal access token.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.gitbook.com/v1/user",
  },
});
